import { PermissionsEnum } from '../enums/PermissionsEnum';
import { MenuOption } from '../services/menu.service';
import { ViewPath } from './ViewPath';

export const MENU_ITEMS = [
  {
    id: 'dashboard',
    name: 'Dashboard',
    label: 'Panel',
    icon: 'dashboard',
    view: ViewPath.dashboard,
    requiredPermissions: [PermissionsEnum.ALL],
    childrenViews: [ViewPath.dashboard],
    parent: undefined,
    children: undefined,
  },

  {
    id: 'clients',
    name: 'Clientes',
    label: 'Clientes',
    icon: 'contacts',
    view: ViewPath.subscriptions,
    requiredPermissions: [PermissionsEnum.CLIENT_READ_LIST],
    childrenViews: [ViewPath.subscriptions],
    parent: undefined,
    children: undefined,
  },

  {
    id: 'users',
    name: 'Usuarios',
    label: 'Usuarios',
    icon: 'contacts_product',
    view: ViewPath.users,
    requiredPermissions: [PermissionsEnum.USER_READ_LIST],
    childrenViews: [ViewPath.users],
    parent: undefined,
    children: undefined,
  },

  {
    id: 'import-status',
    name: 'ImportStatus',
    label: 'Estado de Importaciones',
    icon: 'sync',
    view: ViewPath.importStatus,
    requiredPermissions: [PermissionsEnum.IMPORT_READ_STATUS],
    childrenViews: [ViewPath.importStatus],
    parent: undefined,
    children: undefined,
  },

  {
    id: 'endpoint-timings',
    name: 'EndpointTimings',
    label: 'Rendimiento',
    icon: 'speed',
    view: ViewPath.endpointTimings,
    requiredPermissions: [PermissionsEnum.BACKOFFICE_READ_ENDPOINT_TIMINGS],
    childrenViews: [ViewPath.endpointTimings],
    parent: undefined,
    children: undefined,
  },

  {
    id: 'company-tokens',
    name: 'CompanyTokens',
    label: 'Tokens de compañía',
    icon: 'vpn_key',
    view: ViewPath.companyTokens,
    requiredPermissions: [PermissionsEnum.ALL],
    childrenViews: [ViewPath.companyTokens],
    parent: undefined,
    children: undefined,
  },

  {
    id: 'developer-branch',
    name: 'DeveloperBranch',
    label: 'Ramas',
    icon: 'account_tree',
    view: ViewPath.developerBranch,
    requiredPermissions: [PermissionsEnum.DEVELOPER_READ_BRANCHES],
    childrenViews: [ViewPath.developerBranch],
    parent: undefined,
    children: undefined,
  },

  {
    id: 'developer-database',
    name: 'DeveloperDatabase',
    label: 'Base de datos',
    icon: 'storage',
    view: ViewPath.developerDatabase,
    requiredPermissions: [PermissionsEnum.DEVELOPER_READ_DATABASE],
    childrenViews: [ViewPath.developerDatabase],
    parent: undefined,
    children: undefined,
  },

  {
    id: 'chat-internal',
    name: 'ChatInternal',
    label: 'Lara',
    icon: 'chat',
    view: ViewPath.dashboard,
    requiredPermissions: [PermissionsEnum.CHAT_INTERNAL_READ_CONVERSATIONS],
    childrenViews: [ViewPath.dashboard],
    parent: undefined,
    children: undefined,
  },
];
